import React, { useEffect } from 'react';
import styles from './PixInfo.module.scss';

/* Components */
import { PixInfoBox } from './PixInfoBox/PixInfoBox';

/* Providers */
import { useLoadingContext } from '../../../__providers__/LoadingProvider';
import { useBuyerContext } from '../../../__providers__/BuyerProvider';

interface PixInfoProps {}

export const PixInfo: React.FC<PixInfoProps> = () => {
  const {
    states: { documentNumber, setDocumentNumber },
  } = useBuyerContext();
  const { setLoading } = useLoadingContext();

  useEffect(() => {
    setLoading(documentNumber.length === 0);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className={styles.container}>
      <input
        className={styles.input}
        value={documentNumber}
        required
        placeholder="01234567890"
        onChange={({ target: { value } }) => {
          setDocumentNumber(value);
          setLoading(value.length === 0);
        }}
      />

      <PixInfoBox />
    </div>
  );
};
